import { useAuth } from 'oidc-react';

import { useQuery, useQueryClient } from 'react-query';
import { fetcher } from './fetcher';

export const useEmails = () => {
    const client = useQueryClient();
    const auth = useAuth();
    const { data: emails, status, error, refetch } = useQuery<any[]>(
        'emails',
        () => fetcher( '/api/emails', { token: auth?.userData?.access_token } ),
    );

    return {
        emails: emails ?? [],
        status,
        error,
        refetch
    }
}
